import { any } from 'prop-types';
import './styles.scss';
import React, {useRef} from 'react'
import { deleteDeviceTag, confirmationRequest } from 'signoxe/actions';
import { DEVICE_TAGS_RESOURCE } from 'signoxe/api/resources';
import Icon from '../Icon';
import { connect } from "react-redux";

const DropDownIcon = () => {
    return (
        <svg height="20" width="20" viewBox="0 0 20 20">
        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
        </svg>
    );
};
const CloseIcon = (color) => {
    return (
      <svg fill={color.color} height="20" width="20" viewBox="0 0 20 20">
        <path fill={color.color} d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
      </svg>
    );
};


class SelectSearch extends React.PureComponent {
    constructor(props) {
        super(props);
        this.dropdownMenu_overlayRef = React.createRef();
        this.inputRef = React.createRef();
        this.deleteTag_overlayRef = React.createRef();
        // this.handleClickOut = this.handleClickOut.bind(this);
    
        this.state = {
            dropDown_Open: "",
            searchValue: "",
            selectedValue: props.placeHolder,
            showModal: false,
        }
        
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleOpenModal () {
        this.setState({ showModal: true });
    }
      
    handleCloseModal () {
        this.setState({ showModal: false });
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.inputRef && !this.inputRef.current.contains(event.target) &&
            this.dropdownMenu_overlayRef && !this.dropdownMenu_overlayRef.current.contains(event.target)) {
            this.closeDropDown();
        }
    }

    closeDropDown = () => {
        if (this.dropdownMenu_overlayRef.current) {
            this.dropdownMenu_overlayRef.current.style.height = '0px';
        }
        this.setState({ dropDown_Open: false });
    }

    toggleDropDown_Disp = () => {
        if (this.state.dropDown_Open) {
            this.closeDropDown();
        } else {
            if (this.dropdownMenu_overlayRef.current) {
                this.dropdownMenu_overlayRef.current.style.height = '300px';
            }
            this.setState({ dropDown_Open: true });
        }
    }

    toggleDropDown_Disp = () => {
        if(this.state.dropDown_Open){
            this.dropdownMenu_overlayRef.current.style.height = '0px'
            this.setState({dropDown_Open: false})
            document.removeEventListener("click", this.handleClickOut)
        }else{
            this.dropdownMenu_overlayRef.current.style.height = '300px'
            this.setState({dropDown_Open: true})
            document.addEventListener("click", this.handleClickOut)
        }
    }

    removeOption = (selectedOpt_val) => {
        return this.props.placeHolder.filter((item) => item !== selectedOpt_val);
    };

    onTagRemove = (e, index) => {
        e.stopPropagation();
        this.props.placeHolder.splice(index, 1)
        this.props.onSelect(this.props.placeHolder)
    };

    getDisplay = () => {
        if (this.props.multiple) {
          return (
            <div className="dropdown-selected-value">
                <span className="eyeIcon" onClick={(e)=>{ 
                    if(e && e.stopPropagation) e.stopPropagation(); 
                    this.handleOpenModal()}
                }>
                    <Icon title="Preview Selected Tags" name="eye" size="1rem"/>
                </span>
                {this.props.placeHolder.map((selectedOpt_val, index) => {
                    if(this.props.options.length  != 0){
                        const selected = this.props.options.find((opt)=> opt.value == selectedOpt_val)
                        if(selected != undefined){ return(
                            `${selected.label}, `
                        )}
                    }
                })}
          
            </div>
          );
        }else{
            console.log('multiple = false')
            console.log(this.props.placeHolder )
            return <div className="dropdown-selected-value">{this.props.placeHolder.label}</div>
        }
    };

    isSelected = (option) => {
        if (this.props.multiple) {
          return this.props.placeHolder.filter((o) => o.value === option.value).length > 0;
        }
    
        if (!this.props.placeHolder) {
          return false;
        }
    
        return this.props.placeHolder.value === option.value;
    };
    

    render() {
        const clear = () => {
            this.setState({searchValue: ''})
        }
        
        let newResult = [];
    
        this.props.options.forEach(
            (item) => {
                if(`${item.label}`.toLowerCase().includes(`${this.state.searchValue}`.toLowerCase())) newResult.push(item);
            }
        );

        return (
            <>
                <div className="dropdown-container" style={this.props.style}>
                    <div ref={this.inputRef} className="dropdown-input" onClick={this.toggleDropDown_Disp}>
                        { this.getDisplay() }
                        <div className="dropdown-tools">
                            <div className="dropdown-tool">
                            <DropDownIcon />
                            </div>
                        </div>
                    </div>
                    <div ref={this.dropdownMenu_overlayRef} className="dropdownMenu_overlay">
                        <div className="dropdown-menu">
                            <div className="dropDown_ItemSearch_overlay flex flex-dc">
                                <input 
                                    type="text" 
                                    autoFocus 
                                    list="playlist" 
                                    data-
                                    className="dropDown_ItemSearch"
                                    placeholder='Search...'
                                    value={this.state.searchValue} 
                                    onChange={(e)=>{this.setState({searchValue: e.target.value})}}
                                    name={this.props.name}
                                    id={this.props.id}
                                />
                            </div> 
                           {this.props.loading && <small className='loading-select'>Loading playlists ... </small>}
                            
                            {
                                this.state.searchValue == ''?
                                !this.props.loading && this.props.options.map(
                                        (option) => (
                                            <div className='option'>
                                                <div key={option.value+option.label}
                                                    className={`dropdown-item ${this.isSelected(option) && "selected"}`}
                                                    onClick={(e)=>{
                                                        if(this.props.multiple){
                                                            console.log(this.props.placeHolder)
                                                            this.props.placeHolder.push(option.value)
                                                            console.log(this.props.placeHolder)
                                                            this.props.onSelect(this.props.placeHolder)
                                                        }else{
                                                            this.props.onSelect(option)
                                                            this.toggleDropDown_Disp()
                                                            clear()
                                                        }
                                                }}>
                                                    {option.label}
                                                </div>
                                                {
                                                    this.props.id == 'SelectTag' && option.label != "-- Choose -- "?
                                                        <div ref={this.deleteTag_overlayRef} className="tagDelIcon" onClick={() => {
                                                            this.props.confirmationRequest(
                                                                "Deleting Tag",
                                                                `Deleting this Tag is permanent and cannot be undone.`,
                                                                "DELETE",
                                                                DEVICE_TAGS_RESOURCE,
                                                                option.value,
                                                            )
                                                            this.closeDropDown();
                                                            
                                                        }}>
                                                            <Icon name="trash-o" size="1rem" title="Delete Tag" onClick={() => {}} />
                                                        </div>
                                                    :null
                                                } 
                                            </div>
                                        )
                                    )
                                :
                                    newResult.map(
                                        (option) => (
                                            <div className='option'>
                                                <div key={option.value} className="dropdown-item" onClick={(e)=>{
                                                    this.props.onSelect(option)
                                                    this.toggleDropDown_Disp()
                                                    clear()
                                                }}>
                                                    {option.label}
                                                </div>
                                                {
                                                    this.props.id == 'SelectTag'?
                                                        <div ref={this.deleteTag_overlayRef} className="tagDelIcon" onClick={() => {
                                                            this.props.confirmationRequest(
                                                                "Deleting Tag",
                                                                `Deleting this Tag is permanent and cannot be undone.`,
                                                                "DELETE",
                                                                DEVICE_TAGS_RESOURCE,
                                                                option.value,
                                                            )
                                                        }}>
                                                            <Icon name="trash-o" size="1rem" title="Remove Tag" onClick={() => {}} />
                                                        </div>
                                                    :null
                                                }
                                            </div>
                                        )
                                    )
                            }
                        </div>
                    </div>
                </div>
                {
                    this.state.showModal?
                        <div className="selectedItemModal_Overlay">
                            <div className='selectedItemModal'>
                                <div className="closeModalBtn_Overlay">
                                    <b>Selected Tags</b>
                                    <button onClick={this.handleCloseModal}><CloseIcon color={'black'}/></button>
                                </div>

                                <div className="dropdown-selected-items">
                                    {this.props.placeHolder.map((selectedOpt_val, index) => {
                                        if(this.props.options.length  != 0){
                                            const selected = this.props.options.find((opt)=> opt.value == selectedOpt_val)
                                            if(selected != undefined){ return(
                                                <button title='Unselect tag' key={selectedOpt_val+index} class="button" onClick={(e) => this.onTagRemove(e, index)} type="button">
                                                    <span class="button__text">{ selected.label }</span>
                                                    <div className='button__icon'> 
                                                        <CloseIcon color={'white'}/>
                                                    </div>
                                                </button>
                                            )}
                                        }
                                    })}
                                </div>
                            </div>
                        </div>
                    : null
                }
            </>
        );
    }
};

const mapStateToProps = (state) => {
    return {
      state,
    };
  };
  
  export default connect(mapStateToProps, {
    confirmationRequest,
    deleteDeviceTag,
})(SelectSearch);

// export default SelectSearch    


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/SelectSearch/index.js